module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.13828/img/templates-homepage/stand-out-icon.svg"